export function formatCurrency(currency: string): string {
  return currency === "VES" ? "Bs. " : currency;
}
